<script setup lang="ts">
    import { ICoachingFormQuestion } from '@/js/services/api/coachingForm/types';
    import { __ } from '@/js/stores/expressions';

    defineProps<{
        question: ICoachingFormQuestion;
    }>();
</script>

<template>
    <div class="mt-5">
        {{ __('coaching-form-answer-type-text-description') }}
    </div>
</template>
